export const getBaseURL = () => {
  const { protocol, port, hostname } = window.location;
  return [protocol, '//', hostname, port ? `:${port}` : '', '/api/v1/'].join(
    ''
  );
};
